module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "SalesPersonDashboardpdf",
    attrs: {
      "id": "SalesPersonDashboardpdf"
    }
  }, [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "gutr mt-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-12 col-sm-12 grid-margin stretch-card"
  }, [_c('div', [_c('b-navbar', {
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "info"
    }
  }, [_c('b-navbar-brand', {
    staticStyle: {
      "padding": "0.475rem 1rem"
    }
  }, [_c('h3', [_vm._v("\n                " + _vm._s(_vm.isFromTeusDashboard ? 'Client Dashboard' : 'Sales Person Dashboard') + "\n              ")]), _vm._v(" "), (_vm.isFromTeusDashboard && (_vm.clientFilter || _vm.selectedClientName)) ? _c('div', {
    staticClass: "client-filter-info"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-filter"
  }), _vm._v("\n                  Client: "), _c('strong', [_vm._v(_vm._s(_vm.selectedClientName || _vm.getClientNameFromId(_vm.clientFilter)))]), _vm._v(" "), (_vm.salesPersonFilter) ? _c('span', [_vm._v("\n                    | Sales Person: "), _c('strong', [_vm._v(_vm._s(_vm.getSalesPersonName(_vm.salesPersonFilter)))])]) : _vm._e()])]) : (_vm.salesPersonFilter && !_vm.isFromTeusDashboard) ? _c('div', {
    staticClass: "client-filter-info"
  }, [_c('small', {
    staticClass: "text-muted"
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("\n                  Sales Person: "), _c('strong', [_vm._v(_vm._s(_vm.getSalesPersonName(_vm.salesPersonFilter)))])])]) : _vm._e()]), _vm._v(" "), _c('b-navbar-nav', {
    staticClass: "ml-auto"
  }, [_c('b-nav-form', [_c('b-button-group', {
    staticClass: "ml-1 text-right",
    attrs: {
      "size": "sm"
    }
  }, [(_vm.isFromTeusDashboard) ? _c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.backToTeusDashboard
    }
  }, [_c('i', {
    staticClass: "fa fa-arrow-left"
  }), _vm._v("\n                    Back to TEUs\n                  ")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.previousDash
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.getPDF
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-download",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-1",
    attrs: {
      "size": "sm",
      "disabled": _vm.ExcelBtnName != 'Export' ? true : false,
      "variant": "outline-info"
    },
    on: {
      "click": _vm.exportToExcel
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.ExcelBtnName) + "\n                    "), (_vm.ExcelBtnName != 'Export') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-card', {
    staticClass: "mt-3"
  }, [_c('b-row', [_c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Range Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.CustomDateList,
      "option-value": "DVal",
      "option-text": "DText",
      "placeholder": "Select",
      "isDisabled": _vm.QFlag
    },
    on: {
      "input": _vm.getCurrentLastDate
    },
    model: {
      value: (_vm.QDFilter),
      callback: function($$v) {
        _vm.QDFilter = $$v
      },
      expression: "QDFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Date Range")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale,
      "disabled": _vm.DFlag ? true : false
    },
    on: {
      "update": _vm.getData
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllBranchList'],
      "id": "branchfilter",
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "All Branches",
      "isDisabled": _vm.$sessionsStorage.get('designation') != 'Admin' ? true : false
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.branchfilter),
      callback: function($$v) {
        _vm.branchfilter = $$v
      },
      expression: "branchfilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Sales Person")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllUserList'],
      "option-value": "userId",
      "option-text": "employeeName",
      "placeholder": "All Sales Persons"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.salesPersonFilter),
      callback: function($$v) {
        _vm.salesPersonFilter = $$v
      },
      expression: "salesPersonFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "All Clients"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.clientFilter),
      callback: function($$v) {
        _vm.clientFilter = $$v
      },
      expression: "clientFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.statusList,
      "option-value": "statusVal",
      "option-text": "statusText",
      "placeholder": "All Status"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.statusFilter),
      callback: function($$v) {
        _vm.statusFilter = $$v
      },
      expression: "statusFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Assignment Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.assignmentTypeList,
      "option-value": "typeVal",
      "option-text": "typeText",
      "placeholder": "All Types"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.assignmentTypeFilter),
      callback: function($$v) {
        _vm.assignmentTypeFilter = $$v
      },
      expression: "assignmentTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Transport Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.transportTypeList,
      "option-value": "transportTypeVal",
      "option-text": "transportTypeText",
      "placeholder": "All Transport Types"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.transportTypeFilter),
      callback: function($$v) {
        _vm.transportTypeFilter = $$v
      },
      expression: "transportTypeFilter"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "3"
    }
  }, [_c('label', [_vm._v("Nomination Shipper")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.nominationShipperList,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "All Shippers"
    },
    on: {
      "input": _vm.getData
    },
    model: {
      value: (_vm.is_nomination_shipper),
      callback: function($$v) {
        _vm.is_nomination_shipper = $$v
      },
      expression: "is_nomination_shipper"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "my-2",
    attrs: {
      "md": "6"
    }
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Reset Filters")])], 1)], 1)], 1), _vm._v(" "), _c('SummaryCards', {
    attrs: {
      "summaryData": _vm.summaryData
    }
  }), _vm._v(" "), _c('b-card', {
    staticClass: "mt-4"
  }, [_c('b-tabs', {
    attrs: {
      "content-class": "mt-3",
      "card": ""
    },
    on: {
      "input": _vm.onTabChange
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Overview",
      "active": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-dashboard"
  }), _vm._v(" Overview\n                  ")]), _vm._v(" "), _c('b-row', [_c('ChartsSection', {
    attrs: {
      "lineChartOptions": _vm.lineChartOptions,
      "lineChartSeries": _vm.lineChartSeries,
      "barChartOptions": _vm.barChartOptions,
      "barChartSeries": _vm.barChartSeries,
      "pieChartOptions": _vm.pieChartOptions,
      "pieChartSeries": _vm.pieChartSeries,
      "donutChartOptions": _vm.donutChartOptions,
      "donutChartSeries": _vm.donutChartSeries
    }
  }), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Recent Leads")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Lead ID")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Lead Date")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Value")]), _vm._v(" "), _c('th', [_vm._v("Sales Person")]), _vm._v(" "), _c('th', [_vm._v("Follow-up Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.leadsData), function(lead, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.navigateToClientTeus(lead)
        }
      }
    }, [_c('td', [_vm._v(_vm._s(lead.leadId))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lead.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(lead.leadDate)))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": lead.status === 'Converted' ?
          'success' :
          lead.status === 'Pending' ?
          'warning' :
          'secondary'
      }
    }, [_vm._v(_vm._s(lead.status))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(lead.value)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(lead.salesPerson))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(lead.followUpDate)))])])
  }), _vm._v(" "), (_vm.leadsData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n                                    No data available\n                                  ")])]) : _vm._e()], 2)])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Performing Clients")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Rank")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Total Revenue")]), _vm._v(" "), _c('th', [_vm._v("Total Bookings")]), _vm._v(" "), _c('th', [_vm._v("Average Order Value")]), _vm._v(" "), _c('th', [_vm._v("Last Booking Date")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.topClientsData), function(client, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.navigateToClientTeus(client)
        }
      }
    }, [_c('td', [_c('b-badge', {
      attrs: {
        "variant": "primary"
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(client.totalRevenue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(client.totalBookings))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(client.avgOrderValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(client.lastBookingDate)))])])
  }), _vm._v(" "), (_vm.topClientsData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "6"
    }
  }, [_vm._v("\n                                    No data available\n                                  ")])]) : _vm._e()], 2)])])])])], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Quotation Summary")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Quotation No")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("Date")]), _vm._v(" "), _c('th', [_vm._v("Value")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Valid Until")]), _vm._v(" "), _c('th', [_vm._v("Sales Person")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.quotationsData), function(quote, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(quote.quotationNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quote.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(quote.quotationDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatCurrency(quote.value)))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": quote.status === 'Approved' ?
          'success' :
          quote.status === 'Pending' ?
          'warning' :
          'danger'
      }
    }, [_vm._v(_vm._s(quote.status))])], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(quote.validUntil)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quote.salesPerson))])])
  }), _vm._v(" "), (_vm.quotationsData.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "7"
    }
  }, [_vm._v("\n                                    No data available\n                                  ")])]) : _vm._e()], 2)])])])])], 1)], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Leads"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Leads\n                  ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Leads Management")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Manage and track customer leads")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by enquiry ID or client name...",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        _vm.debounceSearch('leads')
      }
    },
    model: {
      value: (_vm.leadsSearch),
      callback: function($$v) {
        _vm.leadsSearch = $$v
      },
      expression: "leadsSearch"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [{
          value: '',
          text: 'All Status'
        },
        {
          value: 'Pending',
          text: 'Pending'
        },
        {
          value: 'Converted',
          text: 'Converted'
        },
        {
          value: 'Lost',
          text: 'Lost'
        }
      ],
      "size": "sm"
    },
    on: {
      "change": _vm.onLeadsSearch
    },
    model: {
      value: (_vm.leadsStatus),
      callback: function($$v) {
        _vm.leadsStatus = $$v
      },
      expression: "leadsStatus"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [5, 10, 25, 50],
      "size": "sm"
    },
    on: {
      "change": _vm.onLeadsSearch
    },
    model: {
      value: (_vm.leadsPerPage),
      callback: function($$v) {
        _vm.leadsPerPage = $$v
      },
      expression: "leadsPerPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.loadLeadsData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n                                Refresh\n                              ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.leadsData,
      "fields": _vm.leadsFields,
      "empty-text": 'No leads found',
      "empty-filtered-text": 'No matching leads found',
      "show-empty": "",
      "striped": "",
      "bordered": "",
      "small": "",
      "hover": "",
      "responsive": "sm"
    },
    on: {
      "row-clicked": _vm.navigateToClientTeus
    },
    scopedSlots: _vm._u([{
      key: "status",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Converted' ? 'success' : data.value === 'Pending' ? 'warning' : 'danger'
          }
        }, [_vm._v("\n                                " + _vm._s(data.value) + "\n                              ")])]
      }
    }, {
      key: "loginTime",
      fn: function(data) {
        return [_vm._v("\n                              " + _vm._s(_vm.formatDate(data.value)) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), (_vm.leadsPagination.totalPages > 1) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "total-rows": _vm.leadsPagination.totalItems,
      "per-page": _vm.leadsPagination.itemsPerPage,
      "align": "center",
      "size": "sm"
    },
    on: {
      "change": _vm.onLeadsPageChange
    },
    model: {
      value: (_vm.leadsPagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.leadsPagination, "currentPage", $$v)
      },
      expression: "leadsPagination.currentPage"
    }
  }) : _vm._e()], 1)])], 1)], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Top Clients"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-trophy"
  }), _vm._v(" Top Clients\n                  ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Top Performing Clients")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Clients with highest enquiry volume")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [5, 10, 25, 50],
      "size": "sm"
    },
    on: {
      "change": function($event) {
        _vm.onTopClientsPageChange(1)
      }
    },
    model: {
      value: (_vm.topClientsPerPage),
      callback: function($$v) {
        _vm.topClientsPerPage = $$v
      },
      expression: "topClientsPerPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.loadTopClientsData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n                                Refresh\n                              ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.topClientsData,
      "fields": _vm.topClientsFields,
      "empty-text": 'No top clients found',
      "empty-filtered-text": 'No matching clients found',
      "show-empty": "",
      "striped": "",
      "bordered": "",
      "small": "",
      "hover": "",
      "responsive": "sm"
    },
    scopedSlots: _vm._u([{
      key: "clientName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "enquiryCount",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }])
  }), _vm._v(" "), (_vm.topClientsPagination.totalPages > 1) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "total-rows": _vm.topClientsPagination.totalItems,
      "per-page": _vm.topClientsPagination.itemsPerPage,
      "align": "center",
      "size": "sm"
    },
    on: {
      "change": _vm.onTopClientsPageChange
    },
    model: {
      value: (_vm.topClientsPagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.topClientsPagination, "currentPage", $$v)
      },
      expression: "topClientsPagination.currentPage"
    }
  }) : _vm._e()], 1)])], 1)], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Profit & Loss"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-line-chart"
  }), _vm._v(" Profit & Loss\n                  ")]), _vm._v(" "), _c('b-row', [_c('ProfitLossSection', {
    attrs: {
      "profitLossData": _vm.profitLossData,
      "paginationData": _vm.profitLossPagination,
      "summaryData": _vm.profitLossSummary
    },
    on: {
      "load-profit-loss-data": _vm.handleProfitLossDataLoad
    }
  })], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Expenses"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" Expenses\n                  ")]), _vm._v(" "), _c('b-row', [_c('ExpenseSection', {
    attrs: {
      "expenseData": _vm.expenseData
    }
  })], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Tally Reverse Invoice"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" Tally Reverse Invoice\n                  ")]), _vm._v(" "), _c('b-row', [_c('TallyReverseInvoiceSection', {
    attrs: {
      "tallyReverseInvoiceData": _vm.tallyReverseInvoiceData
    },
    on: {
      "data-loaded": _vm.handleTallyReverseInvoiceDataLoaded
    }
  })], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Quotations"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-file-text"
  }), _vm._v(" Quotations\n                  ")]), _vm._v(" "), _c('b-row', [_c('QuotationsSection', {
    attrs: {
      "quotationsData": _vm.quotationsData
    },
    on: {
      "data-loaded": _vm.handleQuotationsDataLoaded
    }
  })], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Assignments"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-tasks"
  }), _vm._v(" Assignments\n                  ")]), _vm._v(" "), _c('b-row', [_c('AssignmentSection', {
    attrs: {
      "assignmentsData": _vm.assignmentData
    },
    on: {
      "data-loaded": _vm.handleAssignmentDataLoaded
    }
  })], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Console Booking"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-calendar-check-o"
  }), _vm._v(" Console Booking\n                  ")]), _vm._v(" "), _c('b-row', [_c('ConsoleBookingSection', {
    attrs: {
      "consoleBookingData": _vm.consoleBookingData
    }
  })], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Billing"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-credit-card"
  }), _vm._v(" Billing\n                  ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Billing Management")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Track and manage billing records")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by invoice number or client name...",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        _vm.debounceSearch('billing')
      }
    },
    model: {
      value: (_vm.billingSearch),
      callback: function($$v) {
        _vm.billingSearch = $$v
      },
      expression: "billingSearch"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [5, 10, 25, 50],
      "size": "sm"
    },
    on: {
      "change": _vm.onBillingSearch
    },
    model: {
      value: (_vm.billingPerPage),
      callback: function($$v) {
        _vm.billingPerPage = $$v
      },
      expression: "billingPerPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.loadBillingData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n                                Refresh\n                              ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.billingData,
      "fields": _vm.billingFields,
      "empty-text": 'No billing records found',
      "empty-filtered-text": 'No matching billing records found',
      "show-empty": "",
      "striped": "",
      "bordered": "",
      "small": "",
      "hover": "",
      "responsive": "sm"
    },
    scopedSlots: _vm._u([{
      key: "BillingSeries",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "totalAmount",
      fn: function(data) {
        return [_vm._v("\n                              " + _vm._s(_vm.formatCurrency(data.value)) + "\n                            ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.value === 'Paid' ? 'success' : data.value === 'Pending' ? 'warning' : 'danger'
          }
        }, [_vm._v("\n                                " + _vm._s(data.value) + "\n                              ")])]
      }
    }, {
      key: "billDate",
      fn: function(data) {
        return [_vm._v("\n                              " + _vm._s(_vm.formatDate(data.value)) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), (_vm.billingPagination.totalPages > 1) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "total-rows": _vm.billingPagination.totalItems,
      "per-page": _vm.billingPagination.itemsPerPage,
      "align": "center",
      "size": "sm"
    },
    on: {
      "change": _vm.onBillingPageChange
    },
    model: {
      value: (_vm.billingPagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.billingPagination, "currentPage", $$v)
      },
      expression: "billingPagination.currentPage"
    }
  }) : _vm._e()], 1)])], 1)], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Active Clients"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Active Clients\n                  ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Active Clients (Last 90 Days)")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Clients with recent assignments")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by client name...",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        _vm.debounceSearch('activeClients')
      }
    },
    model: {
      value: (_vm.activeClientsSearch),
      callback: function($$v) {
        _vm.activeClientsSearch = $$v
      },
      expression: "activeClientsSearch"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [5, 10, 25, 50],
      "size": "sm"
    },
    on: {
      "change": _vm.onActiveClientsSearch
    },
    model: {
      value: (_vm.activeClientsPerPage),
      callback: function($$v) {
        _vm.activeClientsPerPage = $$v
      },
      expression: "activeClientsPerPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.loadActiveClientsData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n                                Refresh\n                              ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.activeClientsData,
      "fields": _vm.activeClientsFields,
      "empty-text": 'No active clients in the last 90 days',
      "empty-filtered-text": 'No matching records found',
      "show-empty": "",
      "striped": "",
      "bordered": "",
      "small": "",
      "hover": "",
      "responsive": "sm"
    },
    scopedSlots: _vm._u([{
      key: "clientName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "activityCount",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "primary"
          }
        }, [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "lastActivity",
      fn: function(data) {
        return [_vm._v("\n                              " + _vm._s(_vm.formatDate(data.value)) + "\n                            ")]
      }
    }])
  }), _vm._v(" "), (_vm.activeClientsPagination.totalPages > 1) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "total-rows": _vm.activeClientsPagination.totalItems,
      "per-page": _vm.activeClientsPagination.itemsPerPage,
      "align": "center",
      "size": "sm"
    },
    on: {
      "change": _vm.onActiveClientsPageChange
    },
    model: {
      value: (_vm.activeClientsPagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.activeClientsPagination, "currentPage", $$v)
      },
      expression: "activeClientsPagination.currentPage"
    }
  }) : _vm._e()], 1)])], 1)], 1)], 2), _vm._v(" "), _c('b-tab', {
    attrs: {
      "title": "Outstanding"
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fa fa-money"
  }), _vm._v(" Outstanding\n                  ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "mb-4",
    attrs: {
      "md": "12"
    }
  }, [_c('b-card', {
    staticClass: "formCardDash"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h6', {
    staticClass: "card-title mb-0"
  }, [_vm._v("Outstanding Amounts")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Pending payments and dues")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row mb-4"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-warning"
  }, [_c('i', {
    staticClass: "fa fa-money"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.formatCurrency(_vm.outstandingData.totalOutstanding || 0)))]), _vm._v(" "), _c('p', [_vm._v("Total Outstanding")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "card-icon bg-danger"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o"
  })]), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_c('h4', [_vm._v(_vm._s(_vm.outstandingData.count || 0))]), _vm._v(" "), _c('p', [_vm._v("Outstanding Invoices")])])])])]), _vm._v(" "), _c('b-row', {
    staticClass: "mb-3"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "Search by invoice number or client name...",
      "size": "sm"
    },
    on: {
      "input": function($event) {
        _vm.debounceSearch('outstanding')
      }
    },
    model: {
      value: (_vm.outstandingSearch),
      callback: function($$v) {
        _vm.outstandingSearch = $$v
      },
      expression: "outstandingSearch"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": [5, 10, 25, 50],
      "size": "sm"
    },
    on: {
      "change": _vm.onOutstandingSearch
    },
    model: {
      value: (_vm.outstandingPerPage),
      callback: function($$v) {
        _vm.outstandingPerPage = $$v
      },
      expression: "outstandingPerPage"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.loadOutstandingData
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh",
    class: {
      'fa-spin': _vm.isLoading
    }
  }), _vm._v("\n                                Refresh\n                              ")])], 1)], 1), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.outstandingData.outstandingInvoices || [],
      "fields": _vm.outstandingFields,
      "empty-text": 'No outstanding invoices',
      "empty-filtered-text": 'No matching records found',
      "show-empty": "",
      "striped": "",
      "bordered": "",
      "small": "",
      "hover": "",
      "responsive": "sm"
    },
    scopedSlots: _vm._u([{
      key: "invoiceNumber",
      fn: function(data) {
        return [_c('code', [_vm._v(_vm._s(data.value))])]
      }
    }, {
      key: "clientName",
      fn: function(data) {
        return [_c('strong', [_vm._v(_vm._s(data.value || 'Unknown'))])]
      }
    }, {
      key: "amount",
      fn: function(data) {
        return [_vm._v("\n                              " + _vm._s(_vm.formatCurrency(data.value || 0)) + "\n                            ")]
      }
    }, {
      key: "outstandingDate",
      fn: function(data) {
        return [_vm._v("\n                              " + _vm._s(_vm.formatDate(data.value)) + "\n                            ")]
      }
    }, {
      key: "status",
      fn: function(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": "warning"
          }
        }, [_vm._v(_vm._s(data.value || 'Outstanding'))])]
      }
    }])
  }), _vm._v(" "), (_vm.outstandingPagination.totalPages > 1) ? _c('b-pagination', {
    staticClass: "mt-3",
    attrs: {
      "total-rows": _vm.outstandingPagination.totalItems,
      "per-page": _vm.outstandingPagination.itemsPerPage,
      "align": "center",
      "size": "sm"
    },
    on: {
      "change": _vm.onOutstandingPageChange
    },
    model: {
      value: (_vm.outstandingPagination.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.outstandingPagination, "currentPage", $$v)
      },
      expression: "outstandingPagination.currentPage"
    }
  }) : _vm._e()], 1)])], 1)], 1)], 2)], 1)], 1)], 1)], 1)])]), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-45b6fa48","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/dashboard/salesPersonDashboard.vue
// module id = 2572
// module chunks = 0